import { useRouter } from 'next/router';
import { ReactNode } from 'react';

import { Button } from '@reckon-web/button';
import { Heading } from '@reckon-web/heading';
import { Stack } from '@reckon-web/stack';
import { Text } from '@reckon-web/text';
import { CloudOffIcon } from '@reckon-web/icon';
import { Flex } from '@reckon-web/flex';
import { makeId } from '@reckon-web/utils';
import { TextLink } from '@reckon-web/text-link';

export const ErrorScreen = ({
  title,
  body,
  buttonProperties,
  testId = `error-screen`,
}: {
  title?: string;
  body?: ReactNode;
  buttonProperties?: {
    onClick: () => void;
    label: string;
  } | null;
  testId?: string;
}) => {
  const router = useRouter();
  return (
    <Flex
      marginY="xxlarge"
      css={{
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: 440,
        textAlign: 'center',
      }}
      data={{ testid: testId }}
    >
      <Stack gap="xlarge" align="center">
        <CloudOffIcon
          color="dim"
          size="large"
          data-testid={makeId(testId, `cloud-off-icon`)}
        />
        <Heading level="3" align="center">
          {title || 'Oops, something went wrong'}
        </Heading>
        <Text size="small" color="muted">
          {body || (
            <Text>
              The issue may be temporary. Please try again. If the problem
              persists, get in touch with our friendly support team at{' '}
              <TextLink
                href="https://www.theaccessgroup.com/en-au/contact-directory/"
                target="_blank"
                data={{ testid: makeId(testId, 'text-link') }}
              >
                theaccessgroup.com
              </TextLink>
            </Text>
          )}
        </Text>

        {buttonProperties !== null && (
          <Button
            onClick={
              buttonProperties
                ? buttonProperties.onClick
                : () => router.reload()
            }
            size="medium"
            label={buttonProperties ? buttonProperties.label : 'Refresh page'}
            block
            data-testid={makeId(testId, 'refresh-page')}
          />
        )}
      </Stack>
    </Flex>
  );
};
